import agendaApiConfig from "./agendaApiConfig";
import ManageStorage from "src/shared/global/manageStorage";

const procedimientoService = {
  async getServicios(sue_correl) {
    let query = {
      sue_correl: sue_correl,
    };
    // Pasar sue_correl por query params !!!
    return await agendaApiConfig.get(`/agenda-servicio`, {
      params: {
        ...query,
      },
    });
  },
  async getProcedimientos(cod, sue_correl) {
    let query = {
        sue_correl: sue_correl,
    };
    console.log("QUERY PROCEDIMIENTO 88 => ", query);
    
    // Pasar sue_correl por query params !!!
    return await agendaApiConfig.get(`/agenda-procedimiento/${cod}`, {
      params: {
        ...query,
      },
    });
  },
};

export default procedimientoService;
